/**
 * Calculate the number of days since a given date
 * @param {Date} date - The date to compare with today
 * @returns {number} - Number of days since the date
 */
export const calculateDaysSince = (date) => {
    const today = new Date();
    const givenDate = new Date(date);

    // Set hours, minutes, seconds, and milliseconds to 0 for both dates for accurate day calculation
    today.setHours(0, 0, 0, 0);
    givenDate.setHours(0, 0, 0, 0);

    // Calculate the difference in milliseconds
    const diffInMs = today - givenDate;

    // Convert milliseconds to days (1000ms * 60s * 60min * 24h)
    const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    return diffInDays;
};

// Get color based on days passed since creation
export const getDaysPassedColor = (aaroFields, daysPassed) => {
    if (aaroFields?.Kapali) return 'light'; // Light color for closed orders
    if (daysPassed === null) return 'secondary';
    if (daysPassed >= 60) return 'error'; // Critical (60+ days)
    if (daysPassed >= 45) return 'error'; // Warning (45-59 days)
    if (daysPassed >= 30) return 'info'; // Notice (30-44 days)
    if (daysPassed >= 15) return 'info'; // Attention (15-29 days)
    return 'success'; // Good (less than 15 days)
};
